export const BT_WATER_INTRODUCED = 'WATER_INTRODUCED';
export const BT_SPROUT_INTRODUCED = 'SPROUT_INTRODUCED';
export const BT_WORKER_INTRODUCED = 'WORKER_INTRODUCED';



/** WEBPACK FOOTER **
 ** ./src/game/props/propsBT.ts
 **/